export const common = {
  nav: {
    home: 'Anasayfa',
    about: 'Hakkımızda',
    services: 'Hizmetler',
    facility: 'Tesis & Güvenlik',
    blog: 'Bilgi Merkezi',
    contact: 'İletişim',
    getQuote: 'Teklif Al',
    callNow: 'Hemen Ara',
    whatsapp: 'WhatsApp'
  },
  hero: {
    title: 'Muratbey Gümrüğü\'ne Bağlı Güvenilir Antrepo ve Lojistik Hizmetleri',
    subtitle: 'Gümrüklü / gümrüksüz depolama, transit ve lojistik operasyonlarınız için hızlı, güvenli ve şeffaf çözüm.',
    quickQuoteTitle: 'Hızlı Teklif Formu'
  },
  form: {
    fullName: 'Ad Soyad',
    company: 'Firma',
    phone: 'Telefon',
    email: 'E-posta',
    service: 'Hizmet Seçimi',
    message: 'Mesaj',
    kvkk: 'KVKK metnini okudum ve kabul ediyorum',
    submit: 'Teklif İste',
    selectService: 'Hizmet seçiniz'
  },
  services: {
    title: 'Hizmetlerimiz',
    subtitle: 'Size Özel Lojistik Çözümler',
    viewDetails: 'Detaylı Bilgi',
    customsWarehouse: {
      title: 'Gümrüklü Genel Antrepo',
      benefits: [
        'İthalat vergisinden tasarruf',
        '7/24 online takip sistemi',
        'Hızlı gümrük işlemleri'
      ]
    },
    freeWarehouse: {
      title: 'Serbest Depo / Gümrüksüz Depolama',
      benefits: [
        'Esnek depolama süreleri',
        'Modern tesis ve ekipman',
        'Güvenli envanter yönetimi'
      ]
    },
    transit: {
      title: 'Transit Hizmetleri',
      benefits: [
        'Hızlı transit işlemler',
        'Uluslararası deneyim',
        'Kapsamlı dokümantasyon'
      ]
    },
    hazardous: {
      title: 'Tehlikeli Madde Deposu',
      benefits: [
        'Özel güvenlik önlemleri',
        'Lisanslı depolama',
        'Uzman personel'
      ]
    },
    valueAdded: {
      title: 'Katma Değerli Hizmetler',
      benefits: [
        'Ambalajlama ve etiketleme',
        'Barkodlama sistemleri',
        'Konsolidasyon hizmetleri'
      ]
    },
    customs: {
      title: 'Gümrükleme',
      benefits: [
        'Profesyonel gümrük danışmanlığı',
        'Hızlı işlem süreçleri',
        'Tam uyumluluk garantisi'
      ]
    }
  },
  whyUs: {
    title: 'Neden Piramit?',
    subtitle: 'Güven ve Kalite Odaklı Hizmet',
    quality: {
      title: 'Kalite ve Güven',
      desc: 'ISO 9001 standardında prosedürler ve sürekli iyileştirme'
    },
    transparency: {
      title: 'Şeffaf Raporlama',
      desc: '7/24 online takip ve detaylı envanter yönetimi'
    },
    speed: {
      title: 'Hızlı Dönüş',
      desc: '24 saat içinde teklif ve hızlı operasyon süreçleri'
    },
    experience: {
      title: 'Tecrübe',
      desc: '1974\'ten beri lojistik sektöründe güvenilir hizmet'
    }
  },
  facility: {
    title: 'Tesis & Kapasite',
    subtitle: 'Modern Altyapı ve Teknoloji',
    totalArea: 'Toplam 5.000 m² Depolama Alanı',
    customsArea: '2.800 m² Gümrüklü Antrepo',
    freeArea: '2.200 m² Serbest Depo',
    viewGallery: 'Tesisimizi İnceleyin'
  },
  security: {
    title: 'Güvenlik & Teknoloji',
    subtitle: 'Yüksek Standartlarda Koruma',
    camera: {
      title: '7/24 Kamera Sistemi',
      desc: 'Kesintisiz güvenlik izleme'
    },
    alarm: {
      title: 'Alarm Sistemi',
      desc: 'Gelişmiş güvenlik altyapısı'
    },
    fire: {
      title: 'Yangın Söndürme',
      desc: 'Otomatik yangın söndürme sistemi'
    },
    wms: {
      title: 'WMS / ERP Entegrasyonu',
      desc: 'Online envanter erişimi ve yönetimi'
    }
  },
  testimonials: {
    title: 'Müşteri Yorumları',
    subtitle: 'Güvenilir İş Ortağınız'
  },
  cta: {
    title: '24 Saat İçinde Size Dönüş Yapalım',
    subtitle: 'Lojistik ihtiyaçlarınız için hemen teklif alın',
    getQuote: 'Teklif Al',
    callUs: 'Bizi Arayın'
  },
  about: {
    certifications: {
      iso9001: 'Kalite Yönetim Sistemi Sertifikası',
      iso14001: 'Çevre Yönetim Sistemi Sertifikası'
    }
  },
  contact: {
    hero: {
      title: '',
      subtitle: ''
    },
    info: {
      title: 'İletişim Bilgileri',
      description: 'Lojistik ve depolama hizmetlerimiz hakkında detaylı bilgi almak için bizimle iletişime geçebilirsiniz.',
      address: {
        title: 'Adres',
        content: 'Taşocağı Cad. No:26 Mahmutbey 34217 Bağcılar / İstanbul / TÜRKİYE'
      },
      phone: {
        title: 'Telefon'
      },
      fax: {
        title: 'Faks'
      },
      email: {
        title: 'E-posta'
      },
      whatsapp: {
        title: 'WhatsApp'
      },
      workingHours: {
        title: 'Çalışma Saatleri',
        weekdays: 'Pazartesi - Cuma: 08:30 - 17:00',
        saturday: 'Cumartesi: Kapalı',
        sunday: 'Pazar: Kapalı'
      },
      qrCode: 'QR kodu okutarak hızlıca iletişime geçin'
    },
    form: {
      title: 'Bize Yazın',
      description: 'Formu doldurarak bize ulaşabilirsiniz. En kısa sürede size geri dönüş yapacağız.',
      name: 'Ad Soyad / Firma Adı',
      namePlaceholder: 'Adınızı ve soyadınızı girin',
      email: 'E-posta',
      emailPlaceholder: 'ornek@email.com',
      phone: 'Telefon / Mesajınız',
      phonePlaceholder: 'Telefon numaranız',
      message: 'Mesajınız',
      messagePlaceholder: 'Mesajınızı buraya yazın...',
      characters: 'karakter',
      submit: 'Gönder',
      sending: 'Gönderiliyor...',
      successMessage: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
      errorMessage: 'Bir hata oluştu. Lütfen tekrar deneyin.'
    },
    map: {
      title: 'Konum',
      subtitle: 'Tesisimizi ziyaret etmek için haritadan yol tarifi alabilirsiniz'
    }
  },
  infoCenter: {
    hero: {
      title: 'Bilgi Merkezi',
      subtitle: 'Gümrük antrepo mevzuatı ve gerekli belgeler hakkında detaylı bilgi edinin'
    },
    sections: {
      regulations: {
        title: 'Mevzuat ve Yönetmelikler',
        description: 'Gümrük antrepo işletmeciliği ile ilgili güncel mevzuat ve yönetmelikler'
      },
      notifications: {
        title: 'Genel Tebliğler',
        description: 'Gümrük antrepo rejimine ilişkin resmi tebliğler ve güncellemeler'
      },
      forms: {
        title: 'Başvuru Formları',
        description: 'Antrepo açılışı ve işletme için gerekli form ve belgeler'
      }
    },
    documents: {
      download: 'İndir',
      viewAll: 'Tümünü Görüntüle'
    }
  },
  footer: {
    contact: 'İletişim',
    address: 'Taşocağı Cad. No:26 Mahmutbey 34217 Bağcılar / İstanbul / TÜRKİYE',
    phone: 'Telefon',
    fax: 'Faks',
    email: 'E-posta',
    quickLinks: 'Hızlı Bağlantılar',
    workingHours: 'Çalışma Saatleri',
    weekdays: 'Pazartesi - Cuma: 08:30 - 17:00',
    saturday: 'Cumartesi: Kapalı',
    sunday: 'Pazar: Kapalı',
    copyright: '© 2025 Piramit Antrepo & Lojistik. Tüm hakları saklıdır.',
    poweredBy: 'Web Design'
  }
};

export default common;